/**
 * 'LoginForm.routes'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
import auth from '@/services/auth.service'
import LoginView from '@/views/login/login.view'

export default [{
  path: '/',
  name: 'login',
  component: LoginView,
  beforeEnter (to, from, next) {
    if (auth.token()) {
      next({name: 'invoice'})
    } else {
      next()
    }
  }
}]



// WEBPACK FOOTER //
// ./src/router/routes/login.routes.js